// src/pages/fiscal/mdfe/VeiculoCad.js
import React from 'react';
import { Veiculo } from '../../../models/fiscal/Veiculo';
import CadastroFiscalCad from './CadastroFiscalCad';

const campos = [
  { nome: 'placa', label: 'Placa', size: 110, maxLength: 7, upper: true },
  { nome: 'renavam', label: 'RENAVAM', size: 130, mask: '99999999999' },
  { nome: 'uf', label: 'UF', size: 70, maxLength: 2, upper: true },
  { nome: 'tara', label: 'Tara', size: 100, tipo: 'number' },
  { nome: 'capacidadeKG', label: 'Capacidade KG', size: 130, tipo: 'number' },
  { nome: 'capacidadeM3', label: 'Capacidade m³', size: 130, tipo: 'number' },
  { nome: 'tipoRodado', label: 'Rodado', size: 170, options: [
    { value: 1, label: 'Truck' }, { value: 2, label: 'Toco' }, { value: 3, label: 'Cavalo mecânico' },
    { value: 4, label: 'Van' }, { value: 5, label: 'Utilitário' }, { value: 6, label: 'Outros' },
  ] },
  { nome: 'tipoCarroceria', label: 'Carroceria', size: 180, options: [
    { value: 0, label: 'Não aplicável' }, { value: 1, label: 'Aberta' }, { value: 2, label: 'Fechada/Baú' },
    { value: 3, label: 'Graneleira' }, { value: 4, label: 'Porta-contêiner' }, { value: 5, label: 'Sider' },
  ] },
  { nome: 'rntrc', label: 'RNTRC', size: 140 },
  { nome: 'tipo', label: 'Tipo', size: 130, options: [{ value: 1, label: 'Tração' }, { value: 2, label: 'Reboque' }] },
  { nome: 'ativo', label: 'Ativo', tipo: 'check' },
];

const VeiculoCad = (props) => <CadastroFiscalCad {...props} tipo="veiculos" titulo="Veículo" Model={Veiculo} campos={campos} />;
export default VeiculoCad;
